<template>
  <div class="w-full container-home relative"
  @mouseleave="disableVisibility()" 
  >
  <MqResponsive target="xs">
    <div class="logo-mobile">
      <ProgressiveImageLoader :src="setLogo" />
    </div>
  </MqResponsive>
   <primary-slide :data-slides="ground" :config="config" />

    <div
      class="
        container-description
        flex flex-col lg:flex-row
        h-full
        w-full
        top-0 
        absolute
      "
    >
      <div
        v-for="(item, index) in cols"
        :key="index"
        class="w-full lg:w-1/3 p-0 overflow h-full"
        @mouseover ="index!==position && clicked ? disableVisibility() : null" 
        @mouseover.prevent="!mq.xs ? setVisible(index) : null"
      >
        <div class="h-full relative">
          <div class="title-col bottom-2/3 lg:bottom-10 w-full text-center absolute flex flex-col justify-center top-0 cursor-pointer">
            <h3  v-if="index != position" class="text-48cap text-white font-bold capitalize"
            :class="{'hidden': index!==position && mq.xs && clicked}"
            @click.prevent="mq.xs ? setVisible(index) : null"
            
            >
              {{ item.title }}
            </h3>
           
          </div>
          <TransitionGroup name="fade">
            <div
              class="box-col w-screen lg:w-auto h-screen lg:h-full z-50 fixed lg:relative top-0"
              :class="{'bg-fadedark': transparent}"
              v-if="visible && index == position"
            >
            <template v-if="!transparent">
            
                <ProgressiveImageLoader :src="item.img" :className="`object-cover object-center h-screen lg:h-full w-full z-10 absolute`"/>
            
              </template>
              <div
                class="
                  absolute
                  flex flex-col
                  justify-center
                  items-start
                  h-fit
                  p-16
                  text-white text-lg
                  h-screen
                  z-10 
                  -top-36
                  bottom-0
                  m-auto
                "
              >
              <MqResponsive target="xs">
                <div class="absolute top-20 right-20" 
                @click.prevent="disableVisibility()"
                ><i class="fa fa-close" aria-hidden="true"></i></div>
              </MqResponsive>
                
               <span class="max-w-lg block text-5xl md:text-40cap xl:text-40cap 2xl:text-40cap 3xl:text-60cap capitalize font-bold mb-8">{{ item.desc }}</span>
                <div class="scroll-content-ui">
                  <p class="text-1.8rem leading-md md:text-1.4rem 2xl:text-1.4rem 3xl:text-1.8rem ">{{ item.text }}</p>
                  <img :src="item.image ? item.image : '' " class="w-max-full h-auto"/>
                  <button 
                @click="openLink(item.link)"
                class="cta-category text-1.6rem px-8 py-3 mt-6 border bg-azzurro-logo border-white max-w-md hover:bg-white text-white hover:text-black uppercase m-auto"
                >Scopri di più</button>
                </div>
               
              </div>
            </div>
          </TransitionGroup>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import ProgressiveImageLoader from './ProgressiveImageLoader/ProgressiveImageLoader'
import PrimarySlide from './PrimarySlide.vue'
import { MqResponsive } from "vue3-mq";


export default {
  inject: ["mq"],
  name: "grid-home",
  components: {
   PrimarySlide,
   MqResponsive,
   ProgressiveImageLoader
  },
  props: {
    bg: {
      type: String,
      default: "",
    },
    transparent:{
      type:Boolean,
      default:false
    },
    dataCol: {
      type: String,
      default: "",
    },
    setLogo:{
      type: String,
      default:''
    }
  },
  data() {
    return {
      
      position: -1,
      cols: JSON.parse(this.dataCol),
      ground: JSON.parse(this.bg),
      visible: true,
      clicked: false,
      config:{
        navigation:false,
        effect: 'fade',
      }
    };
  },
  mounted() {
    window.gridHome= this
    console.log(this.bg)
  
  },
  methods: {
    setVisible(i) {
      this.position = i;
      this.visible = true
      this.clicked = true
    },
     disableVisibility(){
    this.visible = false
    this.clicked = false
    this.position = -1

  },
  openLink(url){
    window.event.preventDefault()
    window.location.href = url
  }
  },
 
};
</script>

<style lang="scss" scoped>
.container-home {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
  background-color: #000;
  overflow: hidden;
  height: calc(100vh - 150px);
  @screen lg{
  height: calc(100vh - 13.8rem );
  }
  .logo-mobile{
    max-width: 250px;
    position: absolute;
    z-index: 6;
    left: 0;
    right: 0;
    margin: auto;
    top: 6rem;
  }
  .scroll-content-ui{
      @screen mdr{
        top: 0;
        padding-bottom: 200px;
        height: 360px;
        p{
          line-height:1.2;
        }
      } 
    }
  .swiper-container:before {
    content:"";
    position:absolute;
    top:0;
    bottom:0;
    width:100%;
    height:100%;
    z-index:5;
    background:#00000047;
}
  .container-description {
    z-index: 100;
    @screen mdr{
    height: calc(100% / 3);
    top: 50%;
    }
    .title-col{
      animation:  0.5s linear 0s 1 transateUp;
      opacity:0;
      animation-fill-mode: forwards;
      @keyframes transateUp {
      from { transform:translateY(20%);
             opacity: 0;
             }
      to   { transform:translateY(0%);
             opacity:1;
            }
      }
      .title-col-desc{
        opacity:0;
        animation:  0.5s linear 0.6s 1 fadeUp;
        animation-fill-mode: forwards;
      @keyframes fadeUp {
      to { opacity:1;}
      }
      }
      
    }
    .box-col {
      &.bg-fadedark{
        background-color: #000000a3;
      }
      img {
        filter: brightness(40%);
      }
      .cta-category{
        letter-spacing: 1px;
        line-height: 24px;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .3s ease-in;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>